import React, { useEffect } from "react";
import "./WorkStyle.css";
import covidMap from "../static/covidMap.JPG";
import map2 from "../static/account.JPG";
import map3 from "../static/drag-drop.JPG";
import Aos from "aos";
import "aos/dist/aos.css";

const Work = () => {
  useEffect(() => {
    Aos.init({ duration: 2500 });
  }, []);
  return (
    <section className="Projects" id="Work">
      <h3 className="WorkH" data-aos="fade-up">
        <a>03.&nbsp;</a>Some Things I've Built <span></span>
      </h3>

      <div data-aos="fade-up">
        <div className="first">
          <h4>Featured Project</h4>
          <h5>
            <a href="https://neqts.github.io/covid19/">Covid Map</a>
          </h5>
          <div className="desc">
            <p>
              Application used to show the number of covid preserved in the
              country . Number of sickness is adjusted for color and legend{" "}
            </p>
          </div>
          <ul>
            <li>JS</li>
            <li>REACT</li>
            <li>JSON</li>
            <li>LEAFLET</li>
            <li>GEOJSON</li>
            <li>VS</li>
          </ul>
          <div className="git">
            <a href="https://github.com/neqts/covid19/tree/master">
              <i className="fab fa-github"></i>
            </a>

            <a href="https://neqts.github.io/covid19/">
              {" "}
              <i className="fas fa-external-link-alt"></i>
            </a>
          </div>
        </div>
        <a>
          <div>
            <div></div>
            <a href="https://neqts.github.io/covid19/">
              <img src={covidMap} />
            </a>
          </div>
        </a>
      </div>

      <div className="validator" data-aos="fade-up">
        <div className="rest">
          <h4>Featured Project</h4>
          <h5>
            <a href="https://neqts.github.io/bankAccount/">Bank Account</a>
          </h5>
          <div className="desc">
            <p>
              A bank application with bank functionality on which for example
              you can simulate an overflow, a loan of money
            </p>
          </div>
          <ul className="match">
            <li>JS</li>
            <li>HTML & CSS</li>
            <li>BANK API</li>
            <li>Visual Studio</li>
          </ul>
          <div className="git2">
            <a href="https://github.com/neqts/bankAccount">
              <i className="fab fa-github"></i>
            </a>

            <a href="https://neqts.github.io/bankAccount/">
              {" "}
              <i className="fas fa-external-link-alt"></i>
            </a>
          </div>
        </div>
        <a className="yolo">
          <div>
            <div></div>
            <a href="https://neqts.github.io/bankAccount/">
              <img src={map2} />
            </a>
          </div>
        </a>
      </div>

      <div data-aos="fade-up">
        <div className="first">
          <h4>Featured Project</h4>
          <h5>
            <a href="https://5fc136241c7659d3534985fe--kind-einstein-1fe37a.netlify.app/">
              Drag&Drop
            </a>
          </h5>
          <div className="desc">
            <p>
              Drag-and-Drop Application - one of the applications offered by GUI
              window managers.{" "}
            </p>
          </div>
          <ul>
            <li>JS</li>
            <li>HTML & CSS</li>
            <li>React</li>
            <li>Drag&Drop</li>
            <li>VS</li>
          </ul>
          <div className="git">
            <a href="https://github.com/neqts/drag-drop">
              <i className="fab fa-github"></i>
            </a>

            <a href="https://5fc136241c7659d3534985fe--kind-einstein-1fe37a.netlify.app/">
              {" "}
              <i className="fas fa-external-link-alt"></i>
            </a>
          </div>
        </div>
        <a>
          <div>
            <div></div>
            <a href="https://5fc136241c7659d3534985fe--kind-einstein-1fe37a.netlify.app/">
              <img src={map3} />
            </a>
          </div>
        </a>
      </div>
    </section>
  );
};

export default Work;
